import React from "react";

/**
 * @group Preview components
 */
export function EmptyValue() {

    return <div
        className="rounded-full bg-surface-200 bg-opacity-30 dark:bg-opacity-20 w-5 h-2 inline-block"/>;
}
